import React, {ReactElement, useEffect, useRef} from 'react'
import tw from 'tailwind-styled-components'
import {ContainerProps} from './types'

export const Container = (props: ContainerProps): ReactElement => {
  const {
    children,
    onClose,
    popupInWnd = false,
    inlineDisplay = false,
    fixedPosition = false,
    overlay,
    zIndex
  } = props
  const containerRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!inlineDisplay) {
      containerRef.current?.focus()
    }
  }, [inlineDisplay])

  const style: React.CSSProperties = {}
  if (overlay?.opacity >= 0) {
    style.opacity = `${Math.max(0, Math.min(1, overlay?.opacity))}`
  }

  return (
    <TwContainer
      tabIndex={0}
      $popupInWnd={popupInWnd}
      $inlineDisplay={inlineDisplay}
      $fixedPosition={fixedPosition}
      ref={containerRef}
      style={zIndex ? {zIndex} : undefined}
    >
      {!inlineDisplay && <TwOverlay onClick={onClose} style={style} />}
      {children}
    </TwContainer>
  )
}

const TwContainer = tw.div<{
  $popupInWnd: boolean
  $fixedPosition: boolean
  $inlineDisplay?: boolean
}>`
  z-1000
  flex
  justify-center

  ${p => (p.$fixedPosition ? 'pt-80 items-start' : 'items-center')}

  ${p => {
    if (p.$inlineDisplay) {
      return ''
    }

    return p.$popupInWnd
      ? `top-0 left-0 fixed w-full h-full`
      : `absolute w-screen h-screen`
  }}
`

const TwOverlay = tw.div`
  fixed
  top-0
  bottom-0
  left-0
  right-0
  bg-generic-black
  opacity-64
`
